import { useIsDesktop } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useMobileFilters } from 'shared/hooks/useMobileFilters';

import { StickyScrollBtn } from '../../components/StickyScrollBtn';
import { selectIsStickyScrollBtnVisible } from '../../selectors/page';
import { useButtonText, useButtonSticky } from './hook';
import { trackAddMyHomeClick } from './tracking';

interface IStickyScrollBtnContainerParams {
  action(): void;
}

export function StickyScrollBtnContainer({ action }: IStickyScrollBtnContainerParams) {
  const isDesktop = useIsDesktop();
  const { openMobileFiltersModal } = useMobileFilters();
  const stickyRef = React.useRef<HTMLElement>(null);

  const isStickyBtnVisible = useSelector(selectIsStickyScrollBtnVisible);

  const buttonText = useButtonText();
  const isBtnSticky = useButtonSticky(stickyRef.current);

  const actionFn = isDesktop ? action : openMobileFiltersModal;

  const handleClick = React.useCallback(() => {
    actionFn();
    trackAddMyHomeClick();
  }, []);

  if (!isStickyBtnVisible) {
    return null;
  }

  return (
    <StickyScrollBtn
      stickyRef={stickyRef as React.Ref<HTMLDivElement>}
      isSticky={isBtnSticky}
      action={handleClick}
      buttonText={buttonText}
      isDesktop={isDesktop}
    />
  );
}
